// 项目配置文件，主要用于common组件中需要获取项目的baseName，vue挂载可用，但是main.js中无法export出配置数据
// 只能先加一个配置文件，- -！

import Vue from 'vue'
Vue.prototype.$config = { baseName: '/backstage' } //这里配置'/reception',打印this.$config.baseName值为'/reception',用于退出

export default {
  // baseName: '/' //这里配置/，接口请求时，console.log(config.baseName)的值为/
  baseName: '/backstage'

}


// WEBPACK FOOTER //
// ./src/common.js